import darkSearchIcon from '../img/searchIcon.svg';
import lightSearchIcon from '../img/searchIcon2.svg';

export const lightTheme = {
    text: 'hsl(200, 15%, 8%)',
    background: 'hsl(0, 0%, 98%)',
    input: 'hsl(0, 0%, 52%)',
    elements: 'hsl(0, 0%, 100%)',
    searchIcon: darkSearchIcon,
}

export const darkTheme = {
    text: 'hsl(0, 0%, 100%)',
    background: 'hsl(207, 26%, 17%)',
    input: 'hsl(209, 23%, 22%)',
    elements: 'hsl(209, 23%, 22%)',
    searchIcon: lightSearchIcon,
}